import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '../context/AuthContext';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <a href="/" style={styles.logo}>CryptoFolio <span style={styles.logoAccent}>CFO</span></a>
        {sent ? (
          <div style={{textAlign:'center'}}>
            <div style={styles.successIcon}>✓</div>
            <h2 style={styles.title}>Check your email</h2>
            <p style={styles.sub}>If that email exists in our system you will receive a reset link shortly.</p>
            <Link to="/login" style={styles.link}>Back to sign in</Link>
          </div>
        ) : (
          <>
            <h1 style={styles.title}>Reset your password</h1>
            <p style={styles.sub}>Enter your email and we'll send you a reset link.</p>
            {error && <div style={styles.error}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div style={styles.field}>
                <label style={styles.label}>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  style={styles.input}
                  placeholder="you@example.com"
                  required
                />
              </div>
              <button type="submit" style={styles.btn} disabled={loading}>
                {loading ? 'Sending...' : 'Send reset link'}
              </button>
            </form>
            <p style={styles.footer}>
              <Link to="/login" style={styles.link}>Back to sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#f4f1eb', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', fontFamily: 'system-ui, sans-serif' },
  card: { background: '#fff', borderRadius: '16px', padding: '2.5rem', width: '100%', maxWidth: '420px', border: '1px solid rgba(0,0,0,0.08)' },
  logo: { fontFamily: 'Georgia, serif', fontSize: '18px', color: '#1a1a1a', textDecoration: 'none', display: 'block', marginBottom: '2rem' },
  logoAccent: { color: '#1a6b4a' },
  title: { fontSize: '24px', fontWeight: '500', color: '#1a1a1a', marginBottom: '0.5rem' },
  sub: { fontSize: '14px', color: '#6b6b6b', marginBottom: '1.5rem', lineHeight: '1.6' },
  error: { background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', padding: '10px 14px', borderRadius: '8px', fontSize: '14px', marginBottom: '1rem' },
  field: { marginBottom: '1rem' },
  label: { display: 'block', fontSize: '13px', fontWeight: '500', color: '#6b6b6b', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.04em' },
  input: { width: '100%', padding: '10px 14px', border: '1px solid rgba(0,0,0,0.12)', borderRadius: '8px', fontSize: '15px', color: '#1a1a1a', outline: 'none', boxSizing: 'border-box', fontFamily: 'system-ui, sans-serif' },
  btn: { width: '100%', padding: '12px', background: '#1a6b4a', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '500', cursor: 'pointer', marginTop: '0.5rem' },
  footer: { textAlign: 'center', fontSize: '13px', color: '#6b6b6b', marginTop: '1.5rem' },
  link: { color: '#1a6b4a', textDecoration: 'none', fontWeight: '500' },
  successIcon: { width: '60px', height: '60px', borderRadius: '50%', background: '#e8f5ef', color: '#1a6b4a', fontSize: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem' }
};
